var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isDisplay)?_c('div',{staticClass:"search-bar-dropdown"},[_c('SearchInput'),_c('BottomLine')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }